const SITE_URL = 'https://socialbunkr.in';

/** BreadcrumbList JSON-LD for deep pages. Pass ordered [label, path] pairs. */
export function breadcrumbSchema(crumbs: Array<[string, string]>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
      ...crumbs.map(([name, path], i) => ({
        '@type': 'ListItem',
        position: i + 2,
        name,
        item: `${SITE_URL}${path}`,
      })),
    ],
  };
}

/** FAQPage JSON-LD from simple question/answer pairs. */
export function faqSchema(faqs: Array<{ q: string; a: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: { '@type': 'Answer', text: a },
    })),
  };
}


export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Social Bunkr',
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  description:
    'Social Bunkr is a short-stay booking platform for budget travellers in India. Book PG beds with 3 meals a day (breakfast, lunch & dinner) by the night across major Indian cities. ₹300–₹500/night, all-inclusive.',
  email: 'support@socialbunkr.in',
  areaServed: 'IN',
  sameAs: [],
};

export const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Social Bunkr',
  url: SITE_URL,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/guest-search-results?city={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const lodgingBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LodgingBusiness',
  name: 'Social Bunkr',
  url: SITE_URL,
  description:
    'Book verified PG beds with 3 meals a day (breakfast, lunch & dinner) across India. All-inclusive short stays from ₹300 to ₹500/night in Bangalore, Hyderabad, Mumbai, Pune, Chennai and more.',
  priceRange: '₹₹',
  areaServed: {
    '@type': 'Country',
    name: 'India',
  },
  amenityFeature: [
    { '@type': 'LocationFeatureSpecification', name: 'Wi-Fi', value: true },
    { '@type': 'LocationFeatureSpecification', name: 'Meals', value: true },
    { '@type': 'LocationFeatureSpecification', name: 'Housekeeping', value: true },
  ],
};

export const landingFaqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is Social Bunkr?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Social Bunkr is a short-stay booking platform where travellers can book PG beds and hostel accommodation across India by the night. It connects budget travellers with verified PG owners who have vacant beds available for short stays.',
      },
    },
    {
      '@type': 'Question',
      name: 'How much does it cost to book on Social Bunkr?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Prices range from ₹300 to ₹500 per night, all-inclusive. Every booking includes three meals a day - breakfast, lunch, and dinner - along with a bed and basic amenities. No hidden charges.',
      },
    },
    {
      '@type': 'Question',
      name: 'Which cities are available on Social Bunkr?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Social Bunkr is available in major Indian cities including Bangalore, Hyderabad, Mumbai, Pune, Chennai, and Delhi, with new cities being added regularly.',
      },
    },
    {
      '@type': 'Question',
      name: 'Are the properties on Social Bunkr verified?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes. All properties listed on Social Bunkr are run by verified PG owners who manage their properties through the Occupi platform. Listings include real photos, amenities, and honest pricing.',
      },
    },
    {
      '@type': 'Question',
      name: 'Are meals included in Social Bunkr stays?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes. Every stay on Social Bunkr includes three meals a day - breakfast, lunch, and dinner. The price you see (₹300–₹500/night) is all-inclusive. There are no extra food charges.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I book a stay on Social Bunkr?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Search for your destination city, browse available PG beds, select your check-in and check-out dates, and pay securely online via UPI or card through Razorpay. You will receive instant booking confirmation.',
      },
    },
  ],
};
